/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![CameraSwapIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABoElEQVR4nO2UPUvDYBDHA6IgCC4OWp0EHR3c9AOIbXPPXYrnXXQvukvrprP4AdxFUdz8BAUHP4GzUMFBfEOnDr6QkvQlfdqmreLiwUFeLv/f5e6fOM5/DBrMPAKkJ4BaMaRfQVaPUY7z+fzwwAAg2Y6ELbnVlyiinwGUuw7CTRnUuiTp5F3HxAG1AqgFYzQVJKAUG0dWrSEtJwZYOixamijG6/oGeN7mVLwmwzz5YwBjNBWvyWZ5umcAoiwnHZEh2bUBXPKXrOJEMg+kb3aAVqoz77DkCBBoZHP+XAsASC5qRT1Y1MRcVD1HObfMXZ7rrynpnr4D0jJ4uhoBAPWpFYD6EDpmxukzsrmN2XBnj5YR6Vn0esw81HQPdKGbePAMkFyGGqcWuj8HJC9hQcn11hdrAJQPQNlvJx40YFCvw/G8W5ccWQxQ7mvzRSm5KDsNdm2CuCQrBuXKkH6Gu7iNrN42XNefANSDwG72H5sWap2T3oTXXg3JITOPOUmDmceN0TUgOWoHCMZoPGFmHnUGCVMH7Dm/EdBlyYMDEtj0z+IbpL9ur4ZKTfEAAAAASUVORK5CYII=)
 */
export const CameraSwapIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M8.62 4.51A2 2 0 0 1 10.56 3h2.88a2 2 0 0 1 1.94 1.51c.06.27.28.49.55.49H17a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h1.07c.27 0 .49-.22.55-.49ZM12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M4 10.35c-1.18.94-2 2.18-2 3.65 0 1.78 1.2 3.22 2.79 4.2 1.15.71 2.6 1.24 4.21 1.53v2.06c0 .45.54.67.85.36l2.8-2.8a.5.5 0 0 0 0-.7l-2.8-2.8a.5.5 0 0 0-.85.36v1.48a10.06 10.06 0 0 1-3.16-1.2C4.54 15.7 4 14.8 4 14v-3.65ZM20 14c0 .61-.31 1.27-1.05 1.92a8.23 8.23 0 0 1-3.22 1.6 1 1 0 0 0 .54 1.92 10.2 10.2 0 0 0 4-2.02A4.59 4.59 0 0 0 22 14c0-1.47-.82-2.7-2-3.65V14Z"
        className={colorClass}
      />
    </svg>
  );
};
